"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.loginSchema = exports.validUser = exports.maxLastNameError = exports.maxFirstNameError = exports.validChangePassword = exports.validForgotPassword = exports.validEmail = exports.validPassword = exports.invalidLoginError = exports.invalidEmailError = exports.maxEmailError = exports.minEmailError = exports.maxPasswordError = exports.minPasswordError = exports.USER_LAST_NAME_MAX_LENGTH = exports.USER_FIRST_LAST_NAME_MAX_LENGTH = exports.USER_EMAIL_MAX_LENGTH = exports.USER_EMAIL_MIN_LENGTH = exports.USER_PASSWORD_MAX_LENGTH = exports.USER_PASSWORD_MIN_LENGTH = void 0;
const errorMessageGenerator_1 = require("../utils/errorMessageGenerator");
const instance_1 = __importDefault(require("./instance"));
exports.USER_PASSWORD_MIN_LENGTH = 6;
exports.USER_PASSWORD_MAX_LENGTH = 2000;
exports.USER_EMAIL_MIN_LENGTH = 3;
exports.USER_EMAIL_MAX_LENGTH = 500;
exports.USER_FIRST_LAST_NAME_MAX_LENGTH = 500;
exports.USER_LAST_NAME_MAX_LENGTH = 500;
exports.minPasswordError = errorMessageGenerator_1.minCharactersError(exports.USER_PASSWORD_MIN_LENGTH);
exports.maxPasswordError = errorMessageGenerator_1.maxCharactersError(exports.USER_PASSWORD_MAX_LENGTH);
exports.minEmailError = errorMessageGenerator_1.minCharactersError(exports.USER_EMAIL_MIN_LENGTH);
exports.maxEmailError = errorMessageGenerator_1.maxCharactersError(exports.USER_EMAIL_MAX_LENGTH);
exports.invalidEmailError = "invalid email";
exports.invalidLoginError = "invalid login";
exports.validPassword = instance_1.default
    .string()
    .min(exports.USER_PASSWORD_MIN_LENGTH, exports.minPasswordError)
    .max(exports.USER_PASSWORD_MAX_LENGTH, exports.maxPasswordError)
    .required(errorMessageGenerator_1.requiredError);
exports.validEmail = instance_1.default
    .string()
    .transform(x => x && x.trim())
    .min(exports.USER_EMAIL_MIN_LENGTH, exports.minEmailError)
    .max(exports.USER_EMAIL_MAX_LENGTH, exports.maxEmailError)
    .email(exports.invalidEmailError)
    .required(errorMessageGenerator_1.requiredError);
exports.validForgotPassword = instance_1.default.object().shape({
    email: instance_1.default
        .string()
        .email(exports.invalidEmailError)
        .required(errorMessageGenerator_1.requiredError)
});
exports.validChangePassword = instance_1.default.object().shape({
    newPassword: exports.validPassword
});
exports.maxFirstNameError = errorMessageGenerator_1.maxCharactersError(exports.USER_FIRST_LAST_NAME_MAX_LENGTH);
exports.maxLastNameError = errorMessageGenerator_1.maxCharactersError(exports.USER_FIRST_LAST_NAME_MAX_LENGTH);
exports.validUser = instance_1.default.object().shape({
    firstName: instance_1.default
        .string()
        .max(exports.USER_FIRST_LAST_NAME_MAX_LENGTH, exports.maxFirstNameError)
        .required(errorMessageGenerator_1.requiredError),
    lastName: instance_1.default
        .string()
        .max(exports.USER_FIRST_LAST_NAME_MAX_LENGTH, exports.maxLastNameError)
        .required(errorMessageGenerator_1.requiredError),
    email: exports.validEmail,
    password: exports.validPassword
});
exports.loginSchema = instance_1.default.object().shape({
    email: instance_1.default.string().required(errorMessageGenerator_1.requiredError),
    password: instance_1.default.string().required(errorMessageGenerator_1.requiredError)
});
//# sourceMappingURL=user.js.map